import { useEffect, useState } from "react";
import type { ScrollMode } from "@cuekards/core/scroll-mode";

/**
 * The live scroll mode, for the two things on the setup screen that draw
 * themselves from it (flow ticket 06).
 *
 * The current value once, then every change — `VoicePanel` reads the live
 * voice-command state the same way, and `WebApp` subscribes to this same
 * broadcast for the WPM. Here rather than in either component because both
 * `FollowVoice` and `ModelPanel` need it and a second copy is a second chance to
 * subscribe to something else.
 *
 * `constant` before the first answer arrives, which is the same thing a browser
 * with nothing stored settles on — so the box below does not tick and untick on
 * the way in.
 */
export function useScrollMode(): ScrollMode {
  const [mode, setMode] = useState<ScrollMode>("constant");

  useEffect(() => {
    let cancelled = false;
    void window.cuekards.getScrollState().then((state) => {
      if (!cancelled) setMode(state.mode);
    });
    const off = window.cuekards.onScrollStateChanged((state) =>
      setMode(state.mode),
    );
    return () => {
      cancelled = true;
      off();
    };
  }, []);

  return mode;
}
